// eslint-disable-next-line @typescript-eslint/no-empty-interface, @typescript-eslint/no-empty-object-type
export interface TranslatableLanguage {}

let translateTempLang = "";

export function setTranslateTempLang(newLang: string) {
	translateTempLang = newLang;
}

export function translateTempImpl(key: string, neutral: string, svSE?: string, enGB?: string) {
	switch (translateTempLang) {
		case "en-SE":
			return neutral;
		case "sv-SE":
			return svSE || key;
		case "en-GB":
			return enGB || neutral || key;
	}
	return neutral;
}
